
import { useEffect, useState } from "react";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Stack,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from '@mui/icons-material/Close';
import { btcGrpCreate, btcGrpGetAll, btcGrpUpdate } from "../../services/btc/btcApi";
import { BtcTitle, MyBtcLayout } from "./BtcAdmin";


export default function BtcInit({navigate}) {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ id: null, group: "", email: "", note: "" });
  const [open, setOpen] = useState(false);


  // snackbar
  const [openSB, setOpenSB] = useState(false);

  useEffect(()=>{
    async function fetchData() {
        // fetch group
        const {result, error} = await btcGrpGetAll();
        if (result) {
            setItems(result);
        } else {
            console.log(error);
        }
    }

    fetchData();
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    setForm({ id: null, group: "", email: "", note: "" });
    setOpen(true);
  };


  const handleEdit = (item) => {
    setForm(item);
    setOpen(true);
  };


  const handleSave = async () => {
    if (!form.group || !form.email) return;

    if (form.id === null) {
        // create new grp {grp, email, note}
        const {result, error} = await btcGrpCreate(form);
        if (error) {
            console.log(error);
            setOpenSB({
                msg: "Thêm nhóm bị lỗi: " + error,
            });
            return;
        }
        
        setOpenSB({
            msg: "Đã thêm nhóm",
        });
        setItems([...items, result]);        
    } else {
        const {result, error} = await btcGrpUpdate(form);
        if (error) {
            console.log(error);
            setOpenSB({
                msg: "Thay đổibị lỗi: " + error,
            });
            return;
        }
        setOpenSB({
            msg: "Đã cập nhật thay đổi",
        });
        setItems(items.map((i) => (i.id === form.id ? form : i)));
    }
    setOpen(false);
  };

  const handleDelete = (id) => {
    setItems(items.filter((i) => i.id !== id));
  };

  // snackbar
  
    const handleCloseSB = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setOpenSB(false);
    };
    const action = (
      <>
        {/* <Button color="secondary" size="small" onClick={handleCloseSB}>
          UNDO
        </Button> */}
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleCloseSB}
        >
          <CloseIcon fontSize="small" />
        </IconButton></>
    );

  return <MyBtcLayout
          title={<BtcTitle navigate={navigate}></BtcTitle>}
          footer={<></>}
        >
          <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box mb={2} display="flex" justifyContent="space-between">
        <Typography variant="h6">Group / Email List</Typography>
        <Button variant="contained" onClick={handleAdd}>Add</Button>
      </Box>
      <Stack spacing={2}>
        {items.map((item) => (
          <Paper key={item.id} sx={{ p: 2 }} variant="outlined">
            <Box display="flex" justifyContent="space-between">
              <Box>
                <Typography fontWeight={600}>{item.group}</Typography>
                <Typography variant="body2" color="text.secondary">{item.email}</Typography>
                <Typography variant="body2">{item.note}</Typography>
              </Box>
              <Box>
                <IconButton onClick={() => handleEdit(item)}>
                  <EditIcon />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(item.id)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          </Paper>
        ))}
      </Stack>


      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>{form.id === null ? "Add" : "Edit"} Entry</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Stack spacing={2} mt={1}>
            <TextField
              label="Group"
              name="group"
              value={form.group}
              onChange={handleChange}
              required
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <TextField
              label="Note"
              name="note"
              value={form.note}
              onChange={handleChange}
              multiline
              rows={3}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>

    <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={!!openSB}
        autoHideDuration={6000}
        onClose={handleCloseSB}
        message={openSB.msg}
        action={action}
    />
    </Container>
        </MyBtcLayout>
}
